import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Modal } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container privacy-policy-content-container">
          <section className="privacy-policy-section">
            <Container className="container-privacy-policy">
              <h2 className="text-center privacy-policy-heading mb-4">Privacy Policy</h2>

              {/* Introduction */}
              <Row className="mb-4">
                <Col>
                  <h3 className="privacy-policy-subheading">Introduction</h3>
                  <p className="privacy-policy-text">
                    Welcome to the Privacy Policy of the All India Occupational Therapists' Association (AIOTA). This policy outlines how we collect, use, disclose, and protect your personal information when you interact with our website and services. We are committed to safeguarding your privacy and ensuring compliance with applicable data protection laws.
                  </p>
                </Col>
              </Row>

              {/* Data Collection */}
              <Row className="mb-4">
                <Col>
                  <h3 className="privacy-policy-subheading">Information We Collect</h3>
                  <div className="privacy-policy-text">
                    We may collect the following types of information:
                    <ul className="privacy-policy-list">
                      <li>Personal details such as name, email address, and phone number provided during registration or form submissions.</li>
                      <li>Usage data, including IP addresses and browser information, collected automatically when you visit our site.</li>
                      <li>Documents or files you upload, such as certificates, for membership or course applications.</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Use of Information */}
              <Row className="mb-4">
                <Col>
                  <h3 className="privacy-policy-subheading">How We Use Your Information</h3>
                  <div className="privacy-policy-text">
                    The information we collect is used for the following purposes:
                    <ul className="privacy-policy-list">
                      <li>To process your membership applications and course registrations.</li>
                      <li>To communicate with you regarding updates, events, or services.</li>
                      <li>To improve our website and tailor content to your preferences.</li>
                      <li>To comply with legal obligations and protect against fraud or misuse.</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Data Security */}
              <Row className="mb-4">
                <Col>
                  <h3 className="privacy-policy-subheading">Data Security</h3>
                  <p className="privacy-policy-text">
                    We implement industry-standard security measures to protect your data, including encryption and secure server storage. However, no online transmission is completely secure, and we cannot guarantee absolute security. We encourage you to use strong passwords and protect your account information.
                  </p>
                </Col>
              </Row>

              {/* Contact Information */}
              <Row className="mb-4">
                <Col>
                  <h3 className="privacy-policy-subheading">Contact Us</h3>
                  <div className="privacy-policy-text">
                    If you have any questions or concerns about this Privacy Policy, please contact us at:
                    <ul className="privacy-policy-list">
                      <li>Email: privacy@aiota.org</li>
                      <li>Phone: +91-22-1234-5678</li>
                      <li>Address: AIOTA Headquarters, Mumbai, India</li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Policy Updates */}
              <Row className="mb-5">
                <Col>
                  <h3 className="privacy-policy-subheading">Policy Updates</h3>
                  <p className="privacy-policy-text">
                    This Privacy Policy may be updated periodically to reflect changes in our practices or legal requirements. We will notify you of significant changes by posting the updated policy on this page with an updated revision date.
                  </p>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;